import React from 'react';
import './HowItWorks.scss';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      id: 1,
      title: 'Crie sua conta',
      description: 'Acesse o 77Gestão em segundos e receba 7 dias de acesso grátis — sem complicação.',
      icon: 'user-plus'
    },
    {
      id: 2,
      title: 'Faça a configuração inicial',
      description: 'Siga o passo a passo ou peça uma demonstração gratúita de um especialista.',
      icon: 'sliders'
    },
    {
      id: 3,
      title: 'Comece a controlar tudo',
      description: 'Registre clientes, vendas, finanças e veja tudo organizado.',
      icon: 'chart-line'
    }
  ];

  return (
    <section id="como-funciona" className="how-it-works">
      <div className="how-it-works-container">
        <div className="how-it-works-header">
          <h2>Como funciona?</h2>
          <p>Comece em 3 passos simples</p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="step-card" data-step={step.id}>
                <div className="step-number">{step.id}</div>
                <div className="step-icon">
                  <i className={`fas fa-${step.icon}`}></i>
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="cta-section">
          <a href="https://app.77gestao.com.br/cadastro?source=howitworks" className="btn-cta" target="_blank" rel="noopener noreferrer">
            Comece agora grátis
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
